/**
 * `YYYY-MM-DD` → `DD/MM/YYYY` sem passar por `Date`: a data de nascimento não
 * tem fuso, e `new Date('2005-07-20')` vira meia-noite UTC — que no Brasil
 * renderiza como 19/07.
 */
export function formatBirthDate(value: string | null | undefined): string | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value?.trim() ?? '');
  if (!match) return null;
  const [, year, month, day] = match;
  return `${day}/${month}/${year}`;
}
